import { Validators } from '@angular/forms';
import { contactValidator } from '$shared/validators/contact-validator';
import { NOTIFICATIONS } from './metadata';
import { BatchMailingData } from './models';
import { shelfLifeRangeValidator } from './utils';

export const BATCH_MAILING_DATA: BatchMailingData = {
  // 'Заказная почтовая карточка республиканская',
  ordered_postcard: {
    specialMarks: ['hand_over_personally'],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      hand_over_personally: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^RR\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      hand_over_personally: {
        value: '',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: true,
        validation: [],
      },
      cash_on_delivery: {
        value: '',
        disabled: true,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: true,
        validation: [],
      },
    },
  },
  // Заказное письмо республиканское
  ordered_letter: {
    specialMarks: ['hand_over_personally', 'subpoena'],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      hand_over_personally: false,
      subpoena: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [
          Validators.pattern(/^(RR|RM|RE|RD|RV|RG|RJ|RY|RC|RP)\d{9}BY$/),
        ],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      hand_over_personally: {
        value: '',
        disabled: false,
        validation: [],
      },
      subpoena: {
        value: '',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(2000),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: true,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: true,
        validation: [],
      },
    },
  },
  // Заказная бандероль республиканская
  ordered_parcel_post: {
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: null,
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^RR\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(2000),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: true,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: true,
        validation: [],
      },
    },
  },
  // Заказной мелкий пакет республиканский
  ordered_small_package: {
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: null,
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^RR\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(2000),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: true,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: true,
        validation: [],
      },
    },
  },
  // Письмо с объявленной ценностью республиканское
  letter_declare_value: {
    formBlanks: true,
    specialMarks: ['hand_over_personally', 'description', 'recipient_payment'],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      hand_over_personally: false,
      description: false,
      recipient_payment: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: true,
        validation: [Validators.pattern(/^VV\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(2000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(999999999),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      hand_over_personally: {
        value: '',
        disabled: false,
        validation: [],
      },
      description: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
    },
  },
  // Мелкий пакет с объявленной ценностью республиканский
  small_package_declare_value: {
    formBlanks: true,
    specialMarks: ['careful_fragile', 'description', 'recipient_payment'],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      careful_fragile: false,
      description: false,
      recipient_payment: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^VV\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(2000),
        ],
      },
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      description: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(999999999),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(6)],
      },
    },
  },
  // Простая посылка республиканская (без ОЦ)
  package: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'description',
      'recipient_payment',
      'bulky',
    ],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      careful_fragile: false,
      description: false,
      recipient_payment: false,
      bulky: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^BP\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(50000),
        ],
      },
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      description: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
    },
  },
  // Посылка с объявленной ценностью республиканская
  package_declare_value: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'description',
      'recipient_payment',
      'bulky',
    ],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      careful_fragile: false,
      description: false,
      recipient_payment: false,
      bulky: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^BV\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(50000),
        ],
      },
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      description: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(999999999),
        ],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
    },
  },
  ecommerce_economical: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'documents_return',
      'bulky',
      'recipient_payment',
    ],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: {
      careful_fragile: false,
      documents_return: false,
      bulky: false,
      recipient_payment: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(30000),
        ],
      },
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      documents_return: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
    },
  },
  ecommerce_standard: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'documents_return',
      'bulky',
      'recipient_payment',
    ],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: {
      careful_fragile: false,
      documents_return: false,
      bulky: false,
      recipient_payment: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(30000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      // addons
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      documents_return: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
    },
  },
  ecommerce_elite: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'documents_return',
      'bulky',
      'recipient_payment',
      'coordinate_delivery_interval',
    ],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: {
      careful_fragile: false,
      documents_return: false,
      bulky: false,
      recipient_payment: false,
      coordinate_delivery_interval: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(50000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      // addons
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      documents_return: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      coordinate_delivery_interval: {
        value: '',
        disabled: false,
        validation: [],
      },
    },
  },
  ecommerce_express: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'documents_return',
      'bulky',
      'recipient_payment',
      'coordinate_delivery_interval',
    ],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: {
      careful_fragile: false,
      documents_return: false,
      bulky: false,
      recipient_payment: false,
      coordinate_delivery_interval: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(10000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      // addons
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      documents_return: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      coordinate_delivery_interval: {
        value: '',
        disabled: false,
        validation: [],
      },
    },
  },
  ecommerce_light: {
    formBlanks: true,
    specialMarks: [],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: null,
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(500),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
    },
  },
  ecommerce_optima: {
    formBlanks: true,
    specialMarks: [],
    notifications: NOTIFICATIONS.filter((el) => ['5'].includes(el.value)),
    addons: null,
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PC\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: null,
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '5',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      shelf_life: {
        value: '10',
        disabled: false,
        validation: [Validators.required, shelfLifeRangeValidator(10, 30)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(501),
          Validators.max(1000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
    },
  },
  // Экспресс-посылка (ранее EMS)
  ems: {
    formBlanks: true,
    specialMarks: [
      'careful_fragile',
      'open_upon_delivery',
      'bulky',
      'recipient_payment',
      'deliver_to_work',
      'time_of_delivery',
      'description',
    ],
    notifications: NOTIFICATIONS.filter((el) =>
      ['0', '1', '2', '5'].includes(el.value)
    ),
    addons: {
      careful_fragile: null,
      open_upon_delivery: null,
      bulky: null,
      recipient_payment: null,
      deliver_to_work: null,
      // for time_of_delivery
      type: null,
      time_interval: null,
      description: false,
    },
    form: {
      id: {
        value: '',
        disabled: false,
        validation: [],
      },
      cost: {
        value: '',
        disabled: false,
        validation: [],
      },
      s10code: {
        value: '',
        disabled: false,
        validation: [Validators.pattern(/^PE\d{9}BY$/)],
      },
      notification_s10code: {
        value: '',
        disabled: true,
        validation: [],
      },
      recipient: {
        value: '',
        disabled: false,
        validation: [Validators.required, contactValidator],
      },
      notification: {
        value: '0',
        disabled: false,
        validation: [],
      },
      email: {
        value: '',
        disabled: false,
        validation: [Validators.email],
      },
      phone: {
        value: '',
        disabled: false,
        validation: [Validators.minLength(9)],
      },
      obtainingMethod: {
        value: '0',
        disabled: false,
        validation: [],
      },
      weight: {
        value: '',
        disabled: false,
        validation: [
          Validators.required,
          Validators.min(1),
          Validators.max(50000),
        ],
      },
      declared_value: {
        value: '',
        disabled: false,
        validation: [Validators.min(1), Validators.max(999999999)],
      },
      cash_on_delivery: {
        value: '',
        disabled: false,
        validation: [Validators.min(0.1), Validators.max(999999999)],
      },
      // addons
      description: {
        value: '',
        disabled: false,
        validation: [],
      },
      careful_fragile: {
        value: '',
        disabled: false,
        validation: [],
      },
      open_upon_delivery: {
        value: '',
        disabled: false,
        validation: [],
      },
      bulky: {
        value: '',
        disabled: false,
        validation: [],
      },
      recipient_payment: {
        value: '',
        disabled: false,
        validation: [],
      },
      deliver_to_work: {
        value: '',
        disabled: true,
        validation: [],
      },
      time_of_delivery: {
        formGroup: [
          {
            name: 'type',
            value: 'level1',
            validation: [Validators.required],
          },
          {
            name: 'time_interval',
            formGroup: {
              from: {
                value: '',
                validation: [],
              },
              to: {
                value: '',
                validation: [],
              },
            },
          },
        ],
        value: '',
        disabled: false,
        validation: [Validators.required],
      },
    },
  },
};
